import { TCol } from "../../../components/layout/listing-table/listing-table.types";
import { formatDate } from "../../../utils/date-format.utils";

export const defaultColumnConfiguration: TCol[] = [
  {
    label: "Date",
    key: "dateCreated",
    render: (row) => formatDate(row.dateCreated, "MMM DD, YYYY")!,
  },
  { label: "SKU", key: "productId" },
  { label: "Change", key: "value" },
];
